
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nos-produits/[...slug]",
      function () {
        return require("private-next-pages/nos-produits/[...slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nos-produits/[...slug]"])
      });
    }
  